import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { PercentTenantRevenue_s } from "components/line-items/line-items-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const DefaultPortfolio = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<string[]|null>(props?.rowData[props?.field] || []);
  const [showSelected, setShowSelected] = useState<boolean>(props?.rowData[props?.field]?.length > 0);
  
  useEffect(() => {
    if (!props['rowData'][props.field]) {
      setData([]);
      setShowSelected(false)
    }
  }, [props['rowData']])

  const updateData = (val:string[]) => {
    setData(val);
    props.persist(val, 'approles', props.rowData);
    if (val.length === 0){
      setShowSelected(false)
    }
  }

  const attrs = (field) => field_attrs('approles')(field)(props.rowData, props)
  let options = ['Administrator', 'Asset Management', 'Standard']

  if (showSelected && data){
    options = options.filter(option => data.includes(option));
  }

  function selectAll():void {
    data?.length === options.length ? updateData([]) : updateData(options)
  }

  if (sortDirty){
    sortAsc ? options.sort((a, b) => alphanum(a, b)) : options.sort((a, b) => alphanum(b, a))
  }

  return (
    <PercentTenantRevenue_s>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Application Access</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: data ? data.length === options.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": data}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={(val)=>updateData(val)}
            options={options.map(option => { return { label: option, value: option }})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </PercentTenantRevenue_s>
  )
}

export default DefaultPortfolio
